import { render, staticRenderFns } from "./NotesCollectionFilters.vue?vue&type=template&id=10007079"
import script from "./NotesCollectionFilters.vue?vue&type=script&lang=ts"
export * from "./NotesCollectionFilters.vue?vue&type=script&lang=ts"
import style0 from "./NotesCollectionFilters.vue?vue&type=style&index=0&id=10007079&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10007079')) {
      api.createRecord('10007079', component.options)
    } else {
      api.reload('10007079', component.options)
    }
    module.hot.accept("./NotesCollectionFilters.vue?vue&type=template&id=10007079", function () {
      api.rerender('10007079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/NotesCollectionFilters.vue"
export default component.exports